import React, { useState, useEffect } from "react";
import "../css/Navbar.css";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false); // mobile nav
  const [openMenus, setOpenMenus] = useState({}); // track open submenus
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  // detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // toggle submenu (only in mobile)
  const toggleMenu = (menu) => {
    if (!isMobile) return; // desktop uses hover only
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  // close mobile nav on link click
  const handleLinkClick = () => {
    setIsOpen(false);
    setOpenMenus({});
  };

  return (
    <nav className="navbar-container">
      {/* Logo */}
      <div className="brand">
        <Link to="/">
         <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Logo" />
        </Link>
      </div>

      {/* Hamburger */}
      <div
        className={`hamburger ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span><span></span><span></span>
      </div>

      {/* Navbar */}
      <div className={`navbar ${isOpen ? "open" : ""}`}>
        <ul>
          <li>
            <Link to="/" onClick={handleLinkClick}>Home</Link>
          </li>

          {/* About */}
          <li>
            <button type="button" onClick={() => toggleMenu("about")}>
              About <span className="arrow">▼</span>
            </button>
            <ul className={openMenus["about"] ? "open" : ""}>
              <li>
                <Link to="/about" onClick={handleLinkClick}>About Digiheal</Link>
              </li>
            </ul>
          </li>

          {/* Services */}
          <li>
            <button type="button" onClick={() => toggleMenu("services")}>
              Our Services <span className="arrow">▼</span>
            </button>
            <ul className={`${openMenus["services"] ? "open" : ""} list`}>

             <li>
                <button type="button" onClick={() => toggleMenu("it")}>
                  IT Services ▶
                </button>
                <ul className={`${openMenus["it"] ? "open" : ""} nested-nested-list`}>
                 <li><Link to="/softwareDev">Software Development & Support</Link></li>
                  <li><Link to="/itConsulting">IT Consulting</Link></li>
                  <li><Link to="/netSolu">Network Solutions</Link></li>
                </ul>
              </li>

              <li>
                <button type="button" onClick={() => toggleMenu("learning")}>
                  Learning & Development ▶
                </button>
                <ul className={`${openMenus["learning"] ? "open" : ""} another-list`}>
                  <li>
                    <button type="button" onClick={() => toggleMenu("instructor")}>
                      Instructor Led Virtual Training ▶
                    </button>
                    <ul className={`${openMenus["instructor"] ? "open nested-list" : "nested-list"} nested-another-list`}>
                      <li><Link to="/basicsOfComputer">Basic Computer Skills</Link></li>
                      <li><Link to="/programmingCoding">Programming & Coding</Link></li>
                      <li><Link to="/webDevelopment">Web Development</Link></li>
                      <li><Link to="/integration">Integration Technologies</Link></li>
                      <li><Link to="/artificialIntelligence">Artificial Intelligence</Link></li>
                    </ul>
                  </li>
                </ul>
              </li>

             
            </ul>
          </li>

          <li>
            <Link to="/contact" onClick={handleLinkClick}>Contact Us</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
